const initialState = {
  pendingCalls: 0,
  pausedCalls: 0,
  concurrencyLimit: 3,
  concurrentCalls: 0,
  isLoading: true,
  lastUpdatedAt: Date.now(),
};

export { initialState };
